import { IonIcon, IonImg } from '@ionic/react';
import { warningOutline } from 'ionicons/icons';
import { FormattedMessage } from 'react-intl';
import { useNewsModal } from '../../hooks/NewsHooks';
import { NewsView } from '../../model/models';
import { Modal } from '../globals/Modal';
import { SanitizeHTML } from '../globals/SanitizeHTML';
import { HouseAuthor } from '../house/HouseAuthor';
import { NewsModalContent } from './NewsModalContent';

export const NewsItem = (news: NewsView, baseUrl: string, key: number) => {
  const { authorImgUrl, houseName, differenceTime } = useNewsModal(news);

  const alertClass = news.alert
    ? 'md:bg-funkyPink text-white'
    : 'bg-white bg-opacity-60';
  const alertClassModal = news.alert
    ? 'bg-funkyPink rounded-3xl p-4 md:p-0 md:rounded-none'
    : '';
  const alertClassText = news.alert ? 'text-white' : 'text-black';
  const alertClassBorder = news.alert ? 'border-white' : 'border-primary';

  return (
    <li
      className={`pb-4 first:pt-0 md:first:p-3 py-3 md:px-3 md:border-0 md:rounded-3xl 
                        cursor-pointer ${alertClass}`}
      key={key}
    >
      <Modal
        content={
          <NewsModalContent
            news={news}
            differenceTime={differenceTime}
            authorImgUrl={authorImgUrl}
            houseName={houseName}
          />
        }
        ModalUrl={baseUrl + '/' + news.slug}
        backUrl={baseUrl}
      >
        <div className={`news-header space-y-4 ${alertClassModal}`}>
          {news.thumbnail_img ? (
            <IonImg
              className="h-56 w-full rounded-3xl object-cover overflow-hidden"
              src={news.thumbnail_img}
            />
          ) : null}
          <div className="relative">
            <SanitizeHTML
              tag="h1"
              html={news.title}
              className={`text-left text-xl font-bold md:ml-2 w-10/12 ${alertClassText}`}
            />
            {news.alert && (
              <IonIcon
                className="text-2xl leading-none absolute top-0 right-0"
                icon={warningOutline}
                color="light"
              />
            )}
          </div>
          <HouseAuthor
            alert={news.alert}
            authorImgUrl={authorImgUrl}
            houseName={houseName}
            differenceTime={differenceTime}
          />
          <SanitizeHTML
            html={news.short_description}
            className={`text-left text-sm ion-text-wrap news-content md:ml-2 ${alertClassText}`}
          />
          <div className="hidden text-left text-xs uppercase ml-2 pt-2 pb-6 font-bold md:block">
            <p className={`border-b ${alertClassBorder} pb-1 md:inline-block`}>
              {' '}
              <FormattedMessage id="See the news" />
              <IonIcon
                slot="icon-only"
                className="text-2xs text-white ml-2"
                src={
                  news.alert
                    ? '/assets/img/arrow-alt-white.svg'
                    : '/assets/img/arrow-alt.svg'
                }
              />
            </p>
          </div>
        </div>
      </Modal>
    </li>
  );
};
